import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TwoDigitAfterDecimalDirectiveDirective } from './two-digit-after-decimal.directive.directive';
import { AutoCompleteDirective } from './auto-complete.directive';



@NgModule({
  declarations: [TwoDigitAfterDecimalDirectiveDirective, AutoCompleteDirective],
  imports: [
    CommonModule
  ],
  exports: [TwoDigitAfterDecimalDirectiveDirective,AutoCompleteDirective ]
})
export class TwoDigitAfterDecimalDirectiveModule { }
